module.exports = __webpack_public_path__ + "img/heibaimofakoudai.min.f06786a4.png";